import gql from 'graphql-tag';

import { QUESTION_FRAGMENT, QUESTION_RESPONSE_FRAGMENT } from 'types/question-response.types';
import { GuestDataForRSVPControl, GuestActivity } from 'types/rsvp_control.types';

export interface GetGuestDataForRSVPControlQueryResponse {
  guestDataForRsvpControl: GuestDataForRSVPControl;
  guestActivity: GuestActivity[];
}

export interface GetGuestDataForRSVPControlQueryVariables {
  gid: string;
  eventId: number;
}

export const GET_GUEST_DATA_FOR_RSVP_CONTROL_QUERY = gql`
  query GetGuestDataForRsvpControl($gid: String!, $eventId: Int!) {
    guestDataForRsvpControl(gid: $gid, eventId: $eventId) {
      guest {
        gid
        userId
        eventId
        email
        firstName
        lastName
        status
        isAttended
        zoomStatus
        meetStatus
        surveySubmittedAt
        surveyResponses {
          ...QuestionResponseFields
        }
        lastUpdatedAt
        profilePictureUrl
        associatedDistrolists {
          id
          name
        }
        associatedCommunities {
          id
          name
        }
        guestType
        plusOnes {
          __typename
          plusOneId
          eventId
          firstName
          lastName
          status
          questionnaireResponses {
            ...QuestionResponseFields
          }
        }
      }
      event {
        id
        title
        eventType
        isPublished
        hasEnded
        createdAt
        createdBy {
          firstName
          lastName
        }
        datetimeScheduled
        allDay
        datetimeEnd
        timezoneCode
        feedbackEnable
        preeventEnable
        isFeedbackAnonymous
        virtualEventInfo {
          hasUnlimitedSpots
        }
        calendarNotifications
        sendCalendarInvites
        calendarProvider
        isEventWaitlisted
        limitRegistration
        plusOneConfig {
          allowPlusOnes
          collectQuestionnaireResponses
          maxPlusOnes
        }
        preEventQuestions {
          ...QuestionFields
        }
        sessions {
          id
          title
          datetimeScheduled
          datetimeEnd
          allDay
          hasEnded
          timezoneCode
          isEventWaitlisted
          plusOneConfig {
            allowPlusOnes
            collectQuestionnaireResponses
            maxPlusOnes
          }
        }
      }
      sessionStatuses {
        id
        status
      }
      parentPlusOnes {
        plusOneId
        eventId
        firstName
        lastName
        questionnaireResponses {
          ...QuestionResponseFields
        }
        sessionStatus {
          eventId
          status
        }
      }
    }
    guestActivity(gid: $gid, eventId: $eventId) {
      __typename
      id
      type
      title
      datetime
      attributionString
    }
  }
  ${QUESTION_FRAGMENT}
  ${QUESTION_RESPONSE_FRAGMENT}
`;
